/**
 * /admin/edd — PEP Enhanced Due Diligence case queue (route shell).
 * Screen impl in `./edd-screen.tsx`, lazy-loaded.
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/edd')({
  component: lazyRouteComponent(() => import('./edd-screen'), 'AdminEdd'),
});
